module.exports = __webpack_public_path__ + "static/media/truckertools-logo.6b8611ef.svg";